import React from 'react';
import logo from '../assets/images/logos.png';

/** Trang hiển thị khi không kết nối được Backend (BE sập / bảo trì). */
const Maintenance: React.FC = () => {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 18,
        padding: 24,
        textAlign: 'center',
        background: '#f9fafb',
      }}
    >
      <img src={logo} alt="TUKI GROUP" style={{ height: 52, width: 'auto' }} />
      <div style={{ fontSize: 56, lineHeight: 1 }}>🛠️</div>
      <h1 style={{ fontSize: '1.6rem', color: '#111827', margin: 0, fontWeight: 700 }}>
        Hệ thống đang bảo trì
      </h1>
      <p style={{ color: '#6b7280', maxWidth: 440, margin: 0, lineHeight: 1.6 }}>
        Xin lỗi vì sự bất tiện. Chúng tôi đang bảo trì hệ thống, vui lòng quay lại sau ít phút.
      </p>
      <button
        onClick={() => window.location.reload()}
        style={{
          marginTop: 6,
          background: 'linear-gradient(135deg, #F30404, #860404)',
          color: '#fff',
          border: 'none',
          padding: '10px 24px',
          borderRadius: 8,
          fontWeight: 600,
          fontSize: '0.95rem',
          cursor: 'pointer',
        }}
      >
        Thử lại
      </button>
    </div>
  );
};

export default Maintenance;
